import { StoreThunk } from './types';
import { setAuthError } from './auth';
import { getAuthError } from '../utils/errors';
import { getEmailVerificationData } from '../reducers/emailVerification';
import { AuthErrorType, EmailVerificationData } from '../types';
import * as built from '../built';
import getAuthModule from '../auth';

const authModule = getAuthModule();

export const SET_EMAIL_VERIFICATION_DATA: 'SET_EMAIL_VERIFICATION_DATA' =
  'SET_EMAIL_VERIFICATION_DATA';

export interface SetEmailVerificationData {
  type: typeof SET_EMAIL_VERIFICATION_DATA;
  emailVerificationData?: EmailVerificationData;
}

/**
 * Set the current email verification data
 */
export function setEmailVerificationData(
  emailVerificationData?: EmailVerificationData
) {
  return {
    type: SET_EMAIL_VERIFICATION_DATA,
    emailVerificationData
  };
}

/**
 * Handles the email verification flow by authenticating
 * with the old email address and password to confirm the
 * user should be doing this; if auth is successsful, we
 * notify BAPI to change their email address
 */
export function verifyEmailAddress(
  previousEmail: string,
  password: string,
  changeId: string,
  changeToken: string
): StoreThunk<Promise<boolean>> {
  return (dispatch, getState) => {
    // reset error states
    dispatch(setAuthError());
    const data = getEmailVerificationData(getState());
    dispatch(
      setEmailVerificationData({
        ...data,
        error: undefined
      })
    );

    return (
      authModule
        // attempt a login with the provided old email and password
        .loginEmailVerification(previousEmail, password)
        // if successful, confirm the email change with BAPI using
        // the auth tokens
        .then(authData => {
          return (
            built
              .confirmEmailVerificationToken(
                changeId,
                changeToken,
                authData.idToken!
              )
              .then(response => {
                return true;
              })
              // catch errors and set the error state to update the view
              .catch(error => {
                const err = getAuthError(
                  AuthErrorType.EMAIL_VERIFICATION_ERROR
                );
                dispatch(
                  setEmailVerificationData({
                    ...data,
                    error: err
                  })
                );
                return false;
              })
          );
        })
        .catch(error => {
          const err = getAuthError(AuthErrorType.INVALID_CREDENTIALS_ERROR);
          dispatch(
            setEmailVerificationData({
              ...data,
              error: err
            })
          );
          return false;
        })
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/emailVerification.ts